/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { GuidItemGroupDto } from './GuidItemGroupDto';
import {
    GuidItemGroupDtoFromJSON,
    GuidItemGroupDtoFromJSONTyped,
    GuidItemGroupDtoToJSON,
} from './GuidItemGroupDto';
import type { InstructionDto } from './InstructionDto';
import {
    InstructionDtoFromJSON,
    InstructionDtoFromJSONTyped,
    InstructionDtoToJSON,
} from './InstructionDto';
import type { ManualTaskWorkStepDto } from './ManualTaskWorkStepDto';
import {
    ManualTaskWorkStepDtoFromJSON,
    ManualTaskWorkStepDtoFromJSONTyped,
    ManualTaskWorkStepDtoToJSON,
} from './ManualTaskWorkStepDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';
import type { WorkItemSource } from './WorkItemSource';
import {
    WorkItemSourceFromJSON,
    WorkItemSourceFromJSONTyped,
    WorkItemSourceToJSON,
} from './WorkItemSource';

/**
 * 
 * @export
 * @interface ManualTaskWorkItemDto
 */
export interface ManualTaskWorkItemDto {
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ManualTaskWorkItemDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ManualTaskWorkItemDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    taskInJobId?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    taskId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    taskAreaId?: string;
    /**
     * 
     * @type {Array<GuidItemGroupDto>}
     * @memberof ManualTaskWorkItemDto
     */
    supportSystemIds?: Array<GuidItemGroupDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof ManualTaskWorkItemDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    description?: string | null;
    /**
     * 
     * @type {InstructionDto}
     * @memberof ManualTaskWorkItemDto
     */
    instruction?: InstructionDto;
    /**
     * 
     * @type {WorkItemSource}
     * @memberof ManualTaskWorkItemDto
     */
    source?: WorkItemSource;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    commentEntityCompositeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ManualTaskWorkItemDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ManualTaskWorkItemDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof ManualTaskWorkItemDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<ManualTaskWorkStepDto>}
     * @memberof ManualTaskWorkItemDto
     */
    workSteps?: Array<ManualTaskWorkStepDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkItemDto
     */
    $type?: ManualTaskWorkItemDtoTypeEnum;
}


/**
 * @export
 */
export const ManualTaskWorkItemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoManualTaskWorkItemDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualTaskWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ManualTaskWorkItemDtoTypeEnum = typeof ManualTaskWorkItemDtoTypeEnum[keyof typeof ManualTaskWorkItemDtoTypeEnum];


/**
 * Check if a given object implements the ManualTaskWorkItemDto interface.
 */
export function instanceOfManualTaskWorkItemDto(value?: unknown): value is ManualTaskWorkItemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ManualTaskWorkItemDtoTypeEnum)[0];
}

export function ManualTaskWorkItemDtoFromJSON(json: any): ManualTaskWorkItemDto {
    return ManualTaskWorkItemDtoFromJSONTyped(json, false);
}

export function ManualTaskWorkItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualTaskWorkItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'taskInJobId': !exists(json, 'taskInJobId') ? undefined : json['taskInJobId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'taskId': !exists(json, 'taskId') ? undefined : json['taskId'],
        'taskAreaId': !exists(json, 'taskAreaId') ? undefined : json['taskAreaId'],
        'supportSystemIds': !exists(json, 'supportSystemIds') ? undefined : (json['supportSystemIds'] === null ? null : (json['supportSystemIds'] as Array<any>).map(GuidItemGroupDtoFromJSON)),
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'taskType': !exists(json, 'taskType') ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'instruction': !exists(json, 'instruction') ? undefined : InstructionDtoFromJSON(json['instruction']),
        'source': !exists(json, 'source') ? undefined : WorkItemSourceFromJSON(json['source']),
        'commentEntityCompositeId': !exists(json, 'commentEntityCompositeId') ? undefined : json['commentEntityCompositeId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'workSteps': !exists(json, 'workSteps') ? undefined : (json['workSteps'] === null ? null : (json['workSteps'] as Array<any>).map(ManualTaskWorkStepDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ManualTaskWorkItemDtoToJSON(value?: ManualTaskWorkItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'taskInJobId': value.taskInJobId,
        'name': value.name,
        'taskId': value.taskId,
        'taskAreaId': value.taskAreaId,
        'supportSystemIds': value.supportSystemIds === undefined ? undefined : (value.supportSystemIds === null ? null : (value.supportSystemIds as Array<any>).map(GuidItemGroupDtoToJSON)),
        'iuid': value.iuid,
        'taskType': TaskTypeDescriptionToJSON(value.taskType),
        'description': value.description,
        'instruction': InstructionDtoToJSON(value.instruction),
        'source': WorkItemSourceToJSON(value.source),
        'commentEntityCompositeId': value.commentEntityCompositeId,
        'commentCount': value.commentCount,
        'lastComment': value.lastComment,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'workSteps': value.workSteps === undefined ? undefined : (value.workSteps === null ? null : (value.workSteps as Array<any>).map(ManualTaskWorkStepDtoToJSON)),
        '$type': value.$type,
    });
}

